"use strict";

/* /collections/all — grid boot. The line filter, its #hash routing and the
   per-line hero copy are gone (base-choice era: the grain is chosen on each
   card via the Oats | Barley picker — see gr-base-choice.js). What remains
   is the anti-FOUC reveal: the grid renders at opacity 0 and fades in once
   the page has settled. NOTHING may run before the reveal that can throw. */
document.addEventListener('DOMContentLoaded', () => {
  const productGrid = document.querySelector('.gr-section--collection-product-grid');
  if (!productGrid) return;
  const productGridInner = productGrid.querySelector('.gr-products-grid');
  const reveal = () => {
    document.querySelectorAll('.gr-pills .gr-pill').forEach(pill => { pill.style.opacity = 1; });
    if (productGridInner) productGridInner.style.opacity = 1;
  };
  if (document.readyState === 'complete') {
    reveal();
  } else {
    window.addEventListener('load', () => setTimeout(reveal, 0));
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const radioButtons = document.querySelectorAll('.gr-box__radio');
  const storageKey = 'grSelectedBox';
  const popupForBoxes = document.querySelector('.gr-popup--for-boxes');
  /* The boxes UI only renders on /collections/all — on the PDP (which loads
     this same script for its embedded grid) there is nothing to wire. */
  if (!popupForBoxes) return;
  const popupMessageElement = popupForBoxes.querySelector('.grJS-popup-message');
  const savedValue = localStorage.getItem(storageKey);
  if (savedValue) {
    radioButtons.forEach(radio => {
      if (radio.value === savedValue) {
        radio.checked = true;
      }
    });
  }
  const updateRadioSelection = () => {
    const cartCounter = window.cartCounter || 0;
    radioButtons.forEach(radio => {
      const radioValue = parseInt(radio.value.split(' ')[0], 10);
      if (radioValue === cartCounter) {
        radio.checked = true;
        localStorage.setItem(storageKey, radio.value);
      }
    });
  };
  radioButtons.forEach((radio, index) => {
    radio.addEventListener('change', () => {
      const selectedValue = parseInt(radio.value.split(' ')[0], 10);
      const cartCounter = window.cartCounter || 0;
      const isLastRadio = index === radioButtons.length - 1;
      if (isLastRadio || selectedValue >= cartCounter) {
        if (radio.checked) {
          localStorage.setItem(storageKey, radio.value);
        }
      } else {
        const template = (window.grI18n && window.grI18n.cart && window.grI18n.cart.reduceMessage)
          || 'Looks like you’re trying to reduce to <strong>%size%</strong>, but you already have <strong>%n%</strong> items in your box.';
        const message = template.split('%size%').join(String(selectedValue)).split('%n%').join(String(cartCounter));
        popupForBoxes.classList.add('gr-active');
        popupMessageElement.innerHTML = message;
        const previousValue = localStorage.getItem(storageKey);
        radioButtons.forEach(r => {
          if (r.value === previousValue) {
            r.checked = true;
          }
        });
      }
    });
  });
  const targetNode = document.querySelector('#cart-icon-bubble');
  if (targetNode) {
    const config = {
      childList: true,
      subtree: true
    };
    const callback = mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const cartCountElement = document.querySelector('.gr-cart-btn__count-bubble .gr-text-small');
          if (cartCountElement) {
            window.cartCounter = parseInt(cartCountElement.textContent, 10);
            updateRadioSelection();
          }
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
});
/* Value Proposition Grid — mobile accordion. Titles stay visible, the body
   expands via a CSS grid-rows transition (class toggle only, no measuring). */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-value-props] [data-vp-toggle]').forEach(head => {
    head.addEventListener('click', () => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      const item = head.closest('.gr-value-props__item');
      if (!item) return;
      const open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open);
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
});
document.addEventListener('DOMContentLoaded', () => {
  const gridContainer = document.querySelector('.gr-main--product-page .gr-products-grid');
  const showMoreButton = document.querySelector('.grJS-show-more-products');
  const productTypePills = document.querySelectorAll('.gr-pills .gr-pill');
  if (!gridContainer || !showMoreButton) return;
  const calculateAndSetHeight = () => {
    const visibleItems = gridContainer.querySelectorAll('.gr-products-grid__item:not([style*="display: none"])');
    const totalHeight = Array.from(visibleItems).reduce((acc, item) => acc + item.offsetHeight, 0);
    const gap = parseFloat(getComputedStyle(gridContainer).gap) || 16;
    const limitedHeight = gap + (visibleItems[0]?.offsetHeight || 0) * 2;
    if (limitedHeight >= totalHeight) {
      gridContainer.style.height = 'auto';
      showMoreButton.style.display = 'none';
    } else {
      gridContainer.style.height = `${limitedHeight}px`;
      showMoreButton.style.display = 'block';
    }
  };
  calculateAndSetHeight();
  showMoreButton.addEventListener('click', () => {
    if (gridContainer.style.height === 'auto') {
      calculateAndSetHeight();
    } else {
      gridContainer.style.height = 'auto';
      showMoreButton.style.display = 'none';
    }
  });
  productTypePills.forEach(pill => {
    pill.addEventListener('click', () => {
      gridContainer.style.height = 'auto';
      showMoreButton.style.display = 'none';
    });
  });
});